import { ROUTING_SECTIONS } from "../../constants";
import {
  WorkOrder,
  WorkOrderInstructions,
  WorkOrderSerialization,
  WorkOrderTesting,
} from "../../containers";
import WorkOrderProd from "./WorkOrderProd";

export const tabs = [
  {
    id: 1,
    label: "Routing & Labor",
    icon: "User",
    TabElement: WorkOrderProd,
  },
  {
    id: 2,
    label: "Instructions",
    icon: "Settings",
    TabElement: WorkOrderInstructions,
  },
  { id: 3, label: "Work Sheet", icon: "FileText", TabElement: WorkOrder },
  { id: 4, label: "Testing", icon: "BarChart2", TabElement: WorkOrderTesting },
  {
    id: 5,
    label: "Serialization",
    icon: "Barcode",
    TabElement: WorkOrderSerialization,
  },
];

const orderRank = (departmentId) => {
  const i = ROUTING_SECTIONS.findIndex((d) => d.departmentId === departmentId);
  return i < 0 ? Number.MAX_SAFE_INTEGER : i;
};

export const getDefaultValues = (data) => ({
  routeId: data?.currentRoute,
  status: data?.state,
  priority: data?.priority,
  instructions: data?.instructions.sort(
    (a, b) => orderRank(a.departmentId) - orderRank(b.departmentId),
  ),
  details: data?.details,
});
